import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CommandMenuState {
  open: boolean;
}

const initialState: CommandMenuState = {
  open: false,
};

export const commandMenuSlice = createSlice({
  name: 'commandMenu',
  initialState,
  reducers: {
    setCommandMenuOpen: (state: CommandMenuState, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    toggleCommandMenu: (state: CommandMenuState) => {
      state.open = !state.open;
    },
  },
});

export const { setCommandMenuOpen, toggleCommandMenu } = commandMenuSlice.actions;

export default commandMenuSlice.reducer;
